import { render, staticRenderFns } from "./fccEtapas.vue?vue&type=template&id=e25be794"
import script from "./fccEtapas.vue?vue&type=script&lang=js"
export * from "./fccEtapas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports